module.exports = __webpack_public_path__ + "static/scale-model-of-dallas-zoo-in-dallas-texas-0edba431c99934c7e90f1abe536d34ca.png";